"use client";

import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);

function HeroText() {
  useGSAP(() => {
    gsap.set(".hero-text", { autoAlpha: 1 });

    SplitText.create(".hero-text", {
      type: "words",
      wordsClass: "hero-word",
      mask: "words",
    });

    const tl = gsap.timeline({ defaults: { ease: "circ.out" } });

    tl.from(
      ".hero-text .hero-word",
      {
        x: "-100%",
        duration: 0.115,
        stagger: 0.05,
      },
      "+=0.7s",
    );
  });

  return (
    <p className="hero-text invisible text-lg text-pretty md:text-xl md:max-w-xl xl:text-xl xl:max-w-xl 2xl:text-2xl 2xl:max-w-2xl">
      We design and build fast, conversion-focused websites. Focus on running
      your business. Not managing your site.
    </p>
  );
}

export { HeroText };
